import { Container } from "semantic-ui-react";
import ListaEstudios from "../../Shared/components/ListaEstudios/ListaEstudios";

import "./Completados.scss";

const Completados = () => {
	return (
		<Container fluid className="container">
			<div className="header">Completados</div>
			<div className="captura">
				<ListaEstudios status="4" />
			</div>
		</Container>
	);
};

export default Completados;
